// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4647":"f54eb9de","7213":"bc1da8cc"}[chunkId] + ".chunk.css";
};